import React, { useCallback } from 'react';
import { Box, Fab, Typography } from '@mui/material';
import { Delete, Download, FilePresent } from '@mui/icons-material';
import { useDownloadSupportChatFile } from 'services/Data/SupportChatServices';
import { BlobStorageTypeEnumValue } from 'enums/BlobStorageTypeEnum';
import mime from 'mime-db';

const SupportFileRow = ({ file, handleRemoveFile, readOnly, styleProps = {} }) => {
  const { mutateAsync: downloadFile } = useDownloadSupportChatFile();
  const handleDownloadFile = useCallback(() => {
    downloadFile(
      file.supportChat_Id
        ? { type: BlobStorageTypeEnumValue.SupportChat, entityId: file.supportChat_Id, fileId: file.id }
        : { type: BlobStorageTypeEnumValue.SupportChatReply, entityId: file.supportChatReply_Id, fileId: file.id },
    ).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      const extension = mime[file.contentType]?.extensions.find(e => file.fileName.endsWith(e));

      link.setAttribute('download', extension ? file.fileName : `${file.fileName}.${extension}`);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }, [downloadFile, file]);

  return (
    <Box
      sx={{
        my: 3,
        ml: 2,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #ddd',
        borderRadius: '.375rem',
        padding: '0.5rem',
        ...styleProps,
      }}>
      <FilePresent />
      <Typography sx={{ mx: 2 }}>{readOnly ? file.fileName : file.name}</Typography>
      {readOnly ? (
        <Fab
          onClick={handleDownloadFile}
          color="primary"
          sx={{
            height: 26,
            width: 26,
            minHeight: 26,
            '& svg': {
              height: 14,
              width: 14,
            },
          }}>
          <Download />
        </Fab>
      ) : (
        <Fab
          onClick={() => handleRemoveFile(file)}
          color="error"
          sx={{
            height: 26,
            width: 26,
            minHeight: 26,
            '& svg': {
              height: 14,
              width: 14,
            },
          }}>
          <Delete />
        </Fab>
      )}
    </Box>
  );
};

export default SupportFileRow;
